import { getUrl, sessionExpired } from "../setEnvironment";

class SystemAPI {
  constructor() {
    this.URL = getUrl();
    this.getTaskPausedStatus = this.getTaskPausedStatus.bind(this);
    this.getPlcStatus = this.getPlcStatus.bind(this);
    this.getPlcPopupStatus = this.getPlcPopupStatus.bind(this);
    this.updatePlcPopupStatus = this.updatePlcPopupStatus.bind(this);
  }

  // P01021-137: el backend ya resolvía esto desde el token, username nunca se llegó a usar.
  async getTaskPausedStatus(token) {
    try {
      const response = await fetch(
        this.URL + "/params/getTaskPausedStatus",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      ).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  async getPlcStatus(token) {
    try {
      const response = await fetch(this.URL + "/plc/getPLCStatus", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async getPlcPopupStatus(token) {
    try {
      const response = await fetch(this.URL + "/plc/getPLCPopupStatus", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async updatePlcPopupStatus(status, token) {
    try {
      const response = await fetch(
        this.URL + `/plc/updatePLCPopupStatus?status=${status}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      ).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }
}
let _systemAPI = null;

const initSystemAPI = () => {
  if (!_systemAPI) {
    _systemAPI = new SystemAPI();
  }
  return _systemAPI;
};

const getSystemAPI = () => {
  return initSystemAPI();
};

export { initSystemAPI, getSystemAPI };
